module.exports = __webpack_public_path__ + "static/media/logotipo-white-clinic.5ec89cb3.png";